import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import ScreenHeader from '../components/ScreenHeader';
import useSWR from 'swr';
import { localAxios } from "../api";
import { workflowStatePath } from "../utils/siteMap";

function RegisterPage() {

  const { data, error, isLoading, mutate } = useSWR('/api/me', localAxios);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [email,      setEmail]     = useState("");
  const [password,   setPassword]  = useState("");
  const [phone,      setPhone]     = useState("");
  const [first_name, setFirstName] = useState("");
  const [last_name,  setLastName]  = useState("");
  const [org,        setOrg]       = useState("");
  const [inviteRoles, setInviteRoles] = useState({ isGuardian: false, isVisitor: false, isInviter: false });
  const [siteId,      setSiteId]      = useState(null);
  const [todayDate]                = useState(new Date());

  useEffect(() => {
    if (data?.data?.loggedIn) {
      if (inviteRoles.isGuardian) {
        navigate('/guardian-confirm');
        return;
      }
      if (inviteRoles.isVisitor || inviteRoles.isInviter) {
        navigate('/visitor-confirm', { state: { siteId, inviteRoles } });
        return;
      }
      navigate(workflowStatePath(data.data.workflow_state) || '/');
    }
  }, [data]);

  useEffect(() => {
    const inviteToken = searchParams.get('invite_token');
    if (!inviteToken) return;
    localAxios.get(`/invite/info?token=${inviteToken}`)
      .then(response => {
        const d = response?.data;
        if (!d) return;
        if (d.email)        setEmail(d.email);
        if (d.first_name)   setFirstName(d.first_name);
        if (d.last_name)    setLastName(d.last_name);
        if (d.organization) setOrg(d.organization);
        if (d.phone)        setPhone(d.phone);
        setInviteRoles({
          isGuardian: d.person_is_guardian        ?? false,
          isVisitor:  d.person_is_visitor         ?? false,
          isInviter:  d.person_will_invite_others ?? false,
        });
        if (d.site_id) setSiteId(d.site_id);
      })
      .catch(err => console.log('Could not pre-fill invite details:', err));
  }, []);

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    const form = event.target;
    let formData = new FormData(form);
    formData.append("todayDate", todayDate.toISOString());

    let formDataObj = Object.fromEntries(formData.entries());
    let formJSON = JSON.stringify(formDataObj);

    return localAxios.post('/register', formJSON).then(async response => {
      if (response) {
        const inviteToken = searchParams.get('invite_token');
        if (inviteToken) {
          try {
            await localAxios.post('/api/invite/accept', JSON.stringify({ token: inviteToken }));
          } catch (err) {
            console.log('Error accepting invitation after registration:', err);
          }
        }
        mutate();
      }
    }).catch((error) => {
      console.log(error);
    });
  };

  return (
    <div className="app-wide__container">
      <ScreenHeader message="Visitor Training Tracker" />

      <div className="app-wide__add-new login__heading">
        <h2 className="login__title">First Time? Please Register.</h2>
      </div>

      <div className="app-wide__main login__main">
        <form id="registerForm" onSubmit={handleFormSubmit} className="login__form">
          <div className="login__field">
            <label className="login__label" htmlFor="reg-email">Email</label>
            <input
              id="reg-email"
              className="login__input"
              type="text"
              autoCapitalize="off"
              name="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div className="login__field">
            <label className="login__label" htmlFor="reg-password">Password</label>
            <input
              id="reg-password"
              className="login__input"
              type="password"
              name="password"
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <div className="login__field">
            <label className="login__label" htmlFor="reg-phone">Phone</label>
            <input
              id="reg-phone"
              className="login__input"
              type="text"
              name="phone"
              value={phone}
              onChange={e => setPhone(e.target.value)}
            />
          </div>
          <div className="login__field">
            <label className="login__label" htmlFor="reg-first">First Name</label>
            <input
              id="reg-first"
              className="login__input"
              type="text"
              name="first_name"
              value={first_name}
              onChange={e => setFirstName(e.target.value)}
            />
          </div>
          <div className="login__field">
            <label className="login__label" htmlFor="reg-last">Last Name</label>
            <input
              id="reg-last"
              className="login__input"
              type="text"
              name="last_name"
              value={last_name}
              onChange={e => setLastName(e.target.value)}
            />
          </div>
          <div className="login__field">
            <label className="login__label" htmlFor="reg-org">Organization <span style={{ fontWeight: 400, color: '#888' }}>(optional)</span></label>
            <input
              id="reg-org"
              className="login__input"
              type="text"
              name="org"
              value={org}
              onChange={e => setOrg(e.target.value)}
            />
          </div>
          <p className="login__register-link">
            Already have an account? <Link to="/login">Please Log In</Link>
          </p>
        </form>
      </div>

      <div className="app-wide__footer login__footer">
        <button type="submit" form="registerForm" className="login__submit-btn">
          Register
        </button>
      </div>
    </div>
  );
}

export default RegisterPage;
